import { Storage, People, Grain, Grass, Map, NaturePeople, Public, FileDownload, Terrain, Dashboard, } from "@mui/icons-material";
export const adminMenuItems = [
    {
        title: "Users",
        description: "Manage access to the administration section.",
        icon: People, // Assign the component directly
        link: "/admin/users",
        buttonText: "Manage Users",
        displayIndex: 2,
    },
    {
        title: "Sites",
        description: "View, insert and update site information.",
        icon: Map, // Assign the component directly
        link: "/admin/sites",
        buttonText: "Manage Sites",
        displayIndex: 6,
    },
    {
        title: "Trials",
        description: "Administration page for managing trials.",
        icon: Storage, // Assign the component directly
        link: "/admin/trials",
        buttonText: "Manage Trials",
        displayIndex: 10,
    },
    {
        title: "Trial Results",
        description: "View, insert and update trial results information for a trial.",
        icon: Grain, // Assign the component directly
        link: "/admin/trial-results",
        buttonText: "Manage Trial Results",
        displayIndex: 14,
    },
    {
        title: "Varieties",
        description: "View, insert and update variety information",
        icon: Grass, // Assign the component directly
        link: "/admin/varieties",
        buttonText: "Manage Varieties",
        displayIndex: 20,
    },
    {
        title: "Species",
        description: "View, insert and update species information",
        icon: NaturePeople, // Assign the component directly
        link: "/admin/species",
        buttonText: "Manage Species",
        displayIndex: 30,
    },
    {
        title: "Regions",
        description: "View, insert and update region information",
        icon: Public, // Assign the component directly
        link: "/admin/regions",
        buttonText: "Manage Regions",
        displayIndex: 40,
    },
    {
        title: "Soil Types",
        description: "View, insert and update soil type information",
        icon: Terrain, // Assign the component directly
        link: "/admin/soil-types",
        buttonText: "Manage Soil Types",
        displayIndex: 45,
    },
    {
        title: "Import Data",
        description: "Import results to a trial",
        icon: FileDownload, // Assign the component directly
        link: "/admin/import-data",
        buttonText: "Import Data",
        displayIndex: 50,
    },
    {
        title: "Site Content",
        description: "Update content for the site",
        icon: Dashboard, // Assign the component directly
        link: "/admin/site-content",
        buttonText: "Manage Site Content",
        displayIndex: 50,
    },
    {
        title: "Trial Documents",
        description: "Upload documents for a trial",
        icon: FileDownload, // Assign the component directly
        link: "/admin/trial-documents",
        buttonText: "Manage Trial Documents",
        displayIndex: 50,
    },
];
